import { useMemo, useState } from 'react';
import useStore from '@/store/store';
import { replaceTonous } from '@/utils/filter-functions';
import { SEARCH_ORDER_FIELDS } from '@/utils/constants';

export const useOrderFilter = activeOrders => {
	const { orderFieldsToSearch, setOrderFieldsToSearch } = useStore();
	const [orderSearchText, setOrderSearchText] = useState('');

	const finalActiveOrders = useMemo(() => {
		if (!orderSearchText || !activeOrders?.length) return activeOrders;

		const hasEnabledField = Object.values(orderFieldsToSearch).some(Boolean);
		if (!hasEnabledField) return activeOrders;

		const searchTextTransformed = replaceTonous(orderSearchText.trim().toLowerCase());

		if (!searchTextTransformed) return activeOrders;

		return activeOrders.filter(it => {
			if (orderFieldsToSearch[SEARCH_ORDER_FIELDS.SHOP_NAME]) {
				if (replaceTonous(it.shop?.name?.toLowerCase?.()).includes(searchTextTransformed))
					return true;
			}

			if (orderFieldsToSearch[SEARCH_ORDER_FIELDS.CLIENT]) {
				if (
					replaceTonous(it.client?.name?.toLowerCase?.()).includes(searchTextTransformed) ||
					replaceTonous(it.client?.f?.toLowerCase?.()).includes(searchTextTransformed) ||
					replaceTonous(it.clientName?.toLowerCase?.()).includes(searchTextTransformed) ||
					replaceTonous(it.client?.p?.toLowerCase?.()).includes(searchTextTransformed) ||
					replaceTonous(it.clientPhone?.toLowerCase?.()).includes(searchTextTransformed)
				)
					return true;
			}

			if (orderFieldsToSearch[SEARCH_ORDER_FIELDS.ADDRESS]) {
				if (replaceTonous(it.address?.s?.toLowerCase?.()).includes(searchTextTransformed))
					return true;
			}

			if (orderFieldsToSearch[SEARCH_ORDER_FIELDS.DELIVERY]) {
				if (
					replaceTonous(it.delivery?.firstname?.toLowerCase?.()).includes(searchTextTransformed) ||
					replaceTonous(it.delivery?.lastname?.toLowerCase?.()).includes(searchTextTransformed)
				)
					return true;
			}

			if (orderFieldsToSearch[SEARCH_ORDER_FIELDS.COMMENTS]) {
				if (replaceTonous(it.comments?.toLowerCase?.()).includes(searchTextTransformed))
					return true;
			}

			return false;
		});
	}, [activeOrders, orderFieldsToSearch, orderSearchText]);

	return {
		orderSearchText,
		setOrderSearchText,
		orderFieldsToSearch,
		setOrderFieldsToSearch,
		finalActiveOrders,
	};
};
